import React from 'react';
import SubscriptionSettings from './SubscriptionSettings';

const SubscriptionWrapper: React.FC = () => {
  return <SubscriptionSettings />;
};

export default SubscriptionWrapper;